import { ReactNode } from "react";
import { Route } from "react-router-dom";
import PageWrapper from "../components/layout/PageWrapper/PageWrapper";
import { RouteType } from "../@types/RouteType";
import { UserRoutes } from "./UserRoutes";


const generateRoutes = (routes: RouteType[]): ReactNode => {
    return routes.map((route, index) => (
        route.index ? (
            <Route
                index
                path={route.path}
                element={
                    <PageWrapper>{route.element}</PageWrapper>}
                key={index}
            />
        ) : (
            <Route
                path={route.path}
                element={
                    <PageWrapper>{route.element}</PageWrapper>
                }
                key={index}
            >
                {route.children && (
                    generateRoutes(route.children)
                )}
            </Route>
        )
    ));
};

export const GeneratedUserRoutes: ReactNode = generateRoutes(UserRoutes);


